import { EligibilityCodeValidationModel } from 'app/shared/constants/common.model';
import { eligibilityCodeRespositoryService } from 'app/shared/services/eligibility-code/eligibility-code-repository.service';

class EligibilityCodeService {
  public async validateEligibilityCode(
    webId: string,
    pCode: string,
    eligibilityValidationSource: string,
    firstName: string = null,
    lastName: string = null
  ): Promise<EligibilityCodeValidationModel> {
    return await eligibilityCodeRespositoryService
      .post({ webId, eligibilityCode: pCode, firstName, lastName, validationSource: eligibilityValidationSource })
      .then((response: EligibilityCodeValidationModel) => {
        return response;
      });
  }
}

export const eligibilityCodeService = new EligibilityCodeService();
